<template>
  <div class="membership-list no-scrollbar">
    <!-- v-on:scroll.passive="checkScrollBottom" -->
    <div class="shops-wrapper no-scrollbar gpu-accelerated">
      <div style="padding-bottom: 100px">
        <div
          class="card shop-card"
          v-for="m in filteredMembers"
          :key="m.id"
          @click="viewMember(m)"
          v-ripple
        >
          <div class="card-content" style="padding: 6px">
            <div class="media" style="margin-bottom: 0">
              <div class="media-left">
                <figure class="image">
                  <img v-webp="memberPic(m)" @error="defaultImg" />
                </figure>
              </div>
              <div class="media-content">
                <p class="shop-name">
                  <span v-if="m.data.name"> {{ m.data.name }} /</span>
                  {{ memberName(m) }}
                </p>
                <p class="categories single-line no-scrollbar">
                  {{ m.phone_number }}
                </p>
                <p
                  v-if="m.data.email"
                  class="categories single-line no-scrollbar"
                >
                  {{ m.data.email }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="has-text-centered">
          <i class="far fa-window-minimize" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus";

export default {
  name: "MembershipList",
  props: {
    members: Array,
    search: String,
  },
  data() {
    return {
      z: 0,
    };
  },
  computed: {
    filteredMembers() {
      var arr = this.members;
      if (!this.search) return arr;
      return arr.filter((m) => {
        var json = JSON.stringify(m);
        return json.toLowerCase().includes(this.search);
      });
    },
  },
  mounted() {
    // this.$nextTick(() => this.scrollToPosition());
  },
  methods: {
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    viewMember(o) {
      console.log("viewMember", o);
    },
    memberName(m) {
      if (m.user) return m.user.name;
      else return m.data.name || m.phone_number;
    },
    filterAndSort(shops) {
      shops = shops.filter((b) => {
        if (this.fulfilment.length == 0) return true; // all okay if none specified
        if (this.fulfilment.includes("delivery")) {
          if (this.isAnyDelivery(b)) return true;
        }
        if (this.fulfilment.includes("take-away")) {
          if (this.isTakeAway(b)) return true;
        }
        if (this.fulfilment.includes("dine-in")) {
          return true;
        }
      });

      shops = shops.filter((b) => {
        if (!b.distance || this.forceRegion) return true;
        return b.distance < this.distance * 1000; // meters
      });

      if (this.cuisines.length > 0) {
        shops = shops.filter((b) => {
          if (!b.data.categories) return false;
          var categories = b.data.categories;
          for (var i = 0; i < this.cuisines.length; i++) {
            if (categories.includes(this.cuisines[i])) return true;
          }
          return false;
        });
      }

      if (this.promos.length > 0) {
        shops = shops.filter((b) => {
          if (this.promos.includes("free-delivery")) {
            if (this.isFreeDelivery(b)) return true;
          }
        });
      }

      // after filtering, sort
      if (this.sortBy === "alphabet") return this.sortAlphabet(shops, "name");
      if (this.sortBy === "distance") return this.sortDistance(shops);
      if (this.sortBy === "new") return this.sortCreatedDate(shops);
      if (this.sortBy === "favorite") return this.sortFavorite(shops);
      if (this.sortBy === "foryou") return this.sortForYou(shops);
      return shops; // default
    },
    commerceWorkflow(b) {
      if (!b.workflows) return false;
      return b.workflows.find((w) => w.workflow_type_name === "Commerce");
    },
    sortAlphabet(arr, field) {
      return arr.sort((a, b) => {
        var textA = a[field].toUpperCase();
        var textB = b[field].toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },

    sortCreatedDate(arr) {
      return arr.sort((a, b) => {
        var dateA = new Date(a.created_at);
        var dateB = new Date(b.created_at);
        return dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
      });
    },
    memberPic(m) {
      if (!m.user)
        return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png";
      return m.user.profile_pic_url;
    },
    openShopPage(businessID) {
      this.$store.commit("selectBusiness", businessID);
      this.gotoDelay(`/shop/${businessID}`); // 300ms delay
      // setTimeout(() => this.$router.push(`/shop/${businessID}`), 250);
    },
  },
};
</script>

<style scoped>
.membership-list {
  width: 100%;
  height: calc(100vh - 125px);
  overflow: hidden;
}
.shops-wrapper {
  border-top: 1px solid rgba(68, 68, 68, 0.2);
  overflow-y: scroll;
  height: 100%;
}
.shop-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100%);
  font-size: 1.15em;
  font-weight: 500;
}
.media-left {
  margin-right: 8px;
  margin-left: 2px;
}
.media-content {
  margin-top: 12px;
  overflow: hidden;
}
figure img {
  border-radius: 3px;
  object-fit: cover;
  height: 90px;
  width: 90px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}
/* .shop-card {
  border: 1px solid rgba(68, 68, 68, 0.2);
} */
.sort-by {
  width: 100vw;
  padding-bottom: 12px;
}
.tag {
  padding: 6px;
}
.button {
  padding: 9px;
}
.distance {
  position: absolute;
  right: 8px;
  bottom: 8px;
  text-shadow: 0 0 1px white;
  /* margin-left: -3px; */
  border-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.heart {
  position: absolute;
  left: 0;
  top: 0;
  /* background-color: rgba(255, 255, 255, 0.8); */
  /* border-radius: 50%; */
  /* text-shadow: 1px 1px 1px grey; */
  /* text-shadow: 0px 0px 4px rgba(128, 128, 128, 0.4); */
  text-shadow: 0px 0px 3px white, 0px 0px 3px white, 0px 0px 3px white,
    1px 1px 3px black;
}
.pre-order {
  position: absolute;
  left: 88px;
  top: 0;
  color: rgb(180, 180, 180);
  text-shadow: 0px 0px 3px white, 0px 0px 3px white, 0px 0px 3px white,
    1px 1px 3px black;
}
.award {
  position: absolute;
  right: 0;
  top: 0;
  margin: 2px;
}
.fast {
  position: absolute;
  right: 22px;
  top: 0;
  margin: 2px;
}
.indicator {
  position: absolute;
  right: 8px;
  bottom: 9px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
}
.closed {
  background-color: rgba(255, 0, 0, 0.4);
}
.open {
  background-color: rgba(19, 223, 19, 0.8);
}
.cannot-find {
  position: relative;
  margin: 10px;
  top: 6px;
  color: grey;
  font-weight: 500;
}
.add-it {
  padding: 20px;
  /* margin-bottom: 20px; */
  position: absolute;
  background-color: rgba(255, 255, 255, 0.1);
  bottom: 0;
  width: 100vw;
  z-index: 1;
}
.no-businesses {
  position: relative;
  margin: 10px;
  top: 6px;
  font-weight: 500;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  /* display: inline-block; */
}
.categories {
  color: grey;
  width: 100%;
  margin-top: -4px;
  margin-bottom: 2px;
}
</style>